export { default as Actions } from './Actions'
export { default as Comments } from './Comments'
export { default as Content } from './Content'
export { default as FeaturedImage } from './FeaturedImage'
export { default as NoArticle } from './NoArticle'
export { default as Ranking } from './Ranking'
export { default as Recommended } from './Recommended'
export { default as SocialIcons } from './SocialIcons'
export { default as User } from './User'


// WEBPACK FOOTER //
// ./src/js/views/Article/components/index.js